import { GetterTree } from 'vuex'
import { AuthState } from './state'
import { RootState } from '@/store'
import { GradeProgress } from '@/core/Auth'
import { PointSubscription } from '@/core/PointSubscriptions'
import { Gender } from '@/core/Programs'

export interface PartialAuthUser {
  id: number
  email: string
  name: string
  nickname: string | null
  romanName: string
  imagePath: string | null
  isExemptedFromDowngrade: boolean
  canPurchaseShortage: boolean
  transactionFee: null | 300
  isCorporateMember: boolean
  pointSubscription: PointSubscription | null
  canceledPointSubscriptionNum: number
  sex: Gender | null
  age: number | null
  prefecture: string | null
  postalCode: string | null
}

export const getters: GetterTree<AuthState, RootState> = {
  ['auth/isLogin']: (state): boolean => {
    return state.email.length !== 0
  },
  ['auth/emailVerified']: (state): boolean => {
    return state.emailVerifiedAt !== null
  },
  ['auth/point']: (state): number => state.point,
  ['auth/user']: (state): PartialAuthUser => {
    return {
      id: state.id,
      email: state.email,
      name: state.name,
      nickname: state.nickname,
      romanName: state.romanName,
      imagePath: state.imagePath,
      isExemptedFromDowngrade: state.isExemptedFromDowngrade,
      canPurchaseShortage: state.canPurchaseShortage,
      transactionFee: state.transactionFee,
      isCorporateMember: state.isCorporateMember,
      pointSubscription: state.pointSubscription,
      canceledPointSubscriptionNum: state.canceledPointSubscriptionNum,
      sex: state.sex,
      age: state.age,
      prefecture: state.prefecture,
      postalCode: state.postalCode,
    }
  },
  ['auth/isSubscribed']: (state): boolean => {
    return (
      (state.pointSubscription?.status === 'active' ||
        state.pointSubscription?.status === 'paused') ??
      false
    )
  },
  ['auth/subscription']: (state): PointSubscription | null => {
    return state.pointSubscription
  },
  ['auth/progress']: (state): GradeProgress | null => {
    return state.progress
  },
  ['auth/sex']: (state): String => {
    return state.sex
  },
  ['auth/passwordWarning']: (state): boolean => {
    return state.passwordWarning ?? false
  },
}
